import { render } from "./UxLayer.vue?vue&type=template&id=072774c0"
import script from "./UxLayer.vue?vue&type=script&lang=js"
export * from "./UxLayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__